import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import t from "../list-item/list-item.js";
import n from "../skeleton/skeleton.js";
import { Fragment as r, createElementBlock as i, createVNode as a, openBlock as o, renderList as s, resolveComponent as c, withCtx as l } from "vue";
//#region components/combobox/combobox_loading-list.vue
var u = {
	name: "ComboboxLoadingList",
	components: {
		DtListItem: t,
		DtSkeleton: n
	}
}, d = {
	class: "d-combobox__loading-list",
	"aria-busy": "true"
};
function f(e, t, n, u, f, p) {
	let m = c("dt-skeleton"), h = c("dt-list-item");
	return o(), i("ol", d, [(o(), i(r, null, s(7, (e) => a(h, {
		key: e,
		role: "option",
		"navigation-type": "none"
	}, {
		default: l(() => [a(m, {
			"text-option": { type: "body" },
			offset: 0
		})]),
		_: 1
	})), 64))]);
}
var p = /* @__PURE__ */ e(u, [["render", f]]);
//#endregion
export { p as default };

//# sourceMappingURL=combobox-loading-list.js.map